import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { Seo } from 'src/components/seo';
import {
  E2eLogicObjectsWithAasoParams,
  e2eLogicUtils_getRoutingLogicObjects,
} from 'src/e2e-redesign/business-logic/e2e-logic-utils';
import PageIntro from 'src/e2e-redesign/components/PageIntro';
import ThemedContainer from 'src/e2e-redesign/components/ThemedContainer';
import {
  getStartedLogic_functionsAndVals,
  getStartedLogic_init,
} from 'src/e2e-redesign/views/get-started/logic/get-started-logic';

import PaymentOptionApplyCard from './payment-option-apply-card';
import PaymentOptionsCard from './payment-options-card';

// fetch disclosure logos

// fetch payment option details

export default function AdditionalPaymentOptions() {
  const routingPackage: E2eLogicObjectsWithAasoParams = e2eLogicUtils_getRoutingLogicObjects();
  getStartedLogic_init(routingPackage);
  console.log('routingPackage', routingPackage);
  const fnv = getStartedLogic_functionsAndVals(routingPackage);
  const { disclosureLogos, drawerState, e2ePath, multi_paths_exist } = fnv.v;
  const { toggleDrawer, handleRouting, handleGoBack } = fnv.fn;
  return (
    <>
      <Seo title="Purchase Options" />
      <ThemedContainer>
        <PageIntro title="Purchase Options" paragraph="Review below" />
        <Box display="flex" flexDirection="column" gap={3}>
          <PaymentOptionsCard />
          <PaymentOptionApplyCard
            logos={disclosureLogos}
            drawerState={drawerState}
            toggleDrawer={toggleDrawer}
            e2ePath={e2ePath}
            onApply={handleRouting}
            multiPathsExist={multi_paths_exist}
            onGoBack={handleGoBack}
          />
        </Box>
      </ThemedContainer>
    </>
  );
}
